

// ================ Action types ================ //

import { createNewInvitationForSTuser, getInvitationList, removeInvitationRequest, resendInvitationRequest } from "../../util/api";

export const INVITATION_LIST_LOADING = 'app/MembersPage/INVITATION_LIST_LOADING';
export const INVITATION_LIST_SUCCESS = 'app/MembersPage/INVITATION_LIST_SUCCESS';
export const INVITATION_LIST_ERROR = 'app/MembersPage/INVITATION_LIST_ERROR';

export const CREATE_INVITATION_LOADING = 'app/MembersPage/CREATE_INVITATION_LOADING';
export const CREATE_INVITATION_SUCCESS = 'app/MembersPage/CREATE_INVITATION_SUCCESS';
export const CREATE_INVITATION_ERROR = 'app/MembersPage/CREATE_INVITATION_ERROR';

export const RESEND_INVITATION_LOADING = 'app/MembersPage/RESEND_INVITATION_LOADING';
export const RESEND_INVITATION_SUCCESS = 'app/MembersPage/RESEND_INVITATION_SUCCESS';
export const RESEND_INVITATION_ERROR = 'app/MembersPage/RESEND_INVITATION_ERROR';

export const REMOVE_INVITATION_LOADING = 'app/MembersPage/REMOVE_INVITATION_LOADING';
export const REMOVE_INVITATION_SUCCESS = 'app/MembersPage/REMOVE_INVITATION_SUCCESS';
export const REMOVE_INVITATION_ERROR = 'app/MembersPage/REMOVE_INVITATION_ERROR';

// ================ Reducer ================ //

const initialState = {
  invitations: [],
  loading: false,
  invitationListError: null,
  createInvitationError: null,
  invitationUpdateError: null,
};

const membersPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case INVITATION_LIST_SUCCESS:
      return { ...state, invitations: payload, loading: false };
    case INVITATION_LIST_ERROR:
      return { ...state, loading: false, invitationListError: payload };
    case INVITATION_LIST_LOADING:
      return { ...state, invitationListError: null, loading: true }
    case CREATE_INVITATION_SUCCESS:
      return { ...state, invitations: payload, loading: false };
    case CREATE_INVITATION_ERROR:
      return { ...state, loading: false, createInvitationError: payload };
    case CREATE_INVITATION_LOADING:
      return { ...state, createInvitationError: null, loading: true }
    case RESEND_INVITATION_SUCCESS:
      return { ...state, loading: false };
    case RESEND_INVITATION_ERROR:
      return { ...state, loading: false, invitationUpdateError: payload };
    case RESEND_INVITATION_LOADING:
      return { ...state, invitationUpdateError: null, loading: true }
    case REMOVE_INVITATION_SUCCESS:
      return { ...state, loading: false };
    case REMOVE_INVITATION_ERROR:
      return { ...state, loading: false, invitationUpdateError: payload };
    case REMOVE_INVITATION_LOADING:
      return { ...state, invitationUpdateError: null, loading: true }
    default:
      return state;
  }
};

export default membersPageReducer;

// ================ Action creators ================ //



// ================ Thunks ================ //
export const getMembersList = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch({ type: INVITATION_LIST_LOADING })

    const inviationList = await getInvitationList(params)
    dispatch({
      type: INVITATION_LIST_SUCCESS,
      payload: inviationList.data,
    })
  } catch (err) {
    dispatch({
      type: INVITATION_LIST_ERROR,
      error: true,
      payload: err,
    })
  }
}

export const createNewInvitation = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch({ type: CREATE_INVITATION_LOADING })

    const updatedInvitationList = await createNewInvitationForSTuser(params)

    dispatch({
      type: CREATE_INVITATION_SUCCESS,
      payload: updatedInvitationList.data,
    })
    return true
  } catch (err) {
    dispatch({
      type: CREATE_INVITATION_ERROR,
      error: true,
      payload: err,
    })
    return false
  }
}

export const resendInvitation = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch({ type: RESEND_INVITATION_LOADING })

    await resendInvitationRequest(params)

    dispatch({
      type: RESEND_INVITATION_SUCCESS,
    })
    return true
  } catch (err) {
    dispatch({
      type: RESEND_INVITATION_ERROR,
      error: true,
      payload: err,
    })
    return false
  }
}

export const removeInvitation = (params) => async (dispatch, getState, sdk) => {
  try {
    dispatch({ type: RESEND_INVITATION_LOADING })

    await removeInvitationRequest(params)
    await dispatch(getMembersList(params))

    dispatch({
      type: RESEND_INVITATION_SUCCESS,
    })
    return true
  } catch (err) {
    dispatch({
      type: RESEND_INVITATION_ERROR,
      error: true,
      payload: err,
    })
    return false
  }
}

export const loadData = (params) => async dispatch => {
  const members = await dispatch(getMembersList(params))
  return members
};
